import {AppState} from 'store';
import {PaymentsState} from './payments.reducer';
import {createSelector} from '@reduxjs/toolkit';

export const paymentsState = (state: AppState): PaymentsState => state.payments;

export const savedCardsSelector = createSelector(
  paymentsState,
  state => state.savedCards
);

export const saveCardCallStateSelector = createSelector(
  paymentsState,
  state => state.saveCardCallState
);

export const getAllCardsCallStateSelector = createSelector(
  paymentsState,
  state => state.getAllCardsCallState
);

export const deleteCardCallStateSelector = createSelector(
  paymentsState,
  state => state.deleteCardCallState
);

export const getSessionKeyInvalid = createSelector(
  paymentsState,
  state => state.sessionKeyInvalid
);

export const saveCardResponseErrorSelector = createSelector(
  paymentsState,
  state => state.saveCardResponseError
);
